import { origin } from './constant';

const ApplicationURI = {
  applicationSettings: `${origin}/application/settings`,
};

export default ApplicationURI;
